import type { UnionAgreement } from '@/libs/interfaces'

import { MOCK_ORG_ID } from './seed'

/** Shared union agreement fixture data. */
export const mockUnionAgreements: UnionAgreement[] = [
  {
    unionAgreementID: 'union-agreement-1',
    orgID: MOCK_ORG_ID,
    createdAt: '2025-01-01T00:00:00.000Z',
    updatedAt: '2025-01-01T00:00:00.000Z',
    name: 'Transport Workers Agreement',
    startAt: '2025-01-01',
    endAt: '2026-12-31',
    limitationPeriod: 24,
    sickDays: 10,
    SickMinutes: 480,
    MinutesPerWeek: 2400,
    vacationDays: 25,
    weekRest: 36,
    dayRest: 11,
    onCallTime: 8,
    maxAnnulOverTime: 200,
    maxMonthlyOverTime: 50,
    maxFourWeekOvertime: 48,
    maxAnnualExceptionalOverTime: 150,
    status: 'Active',
    hourlyRate: '280',
    overTimeHourlyRate: [],
    inconvenienceHours: [],
  },
  {
    unionAgreementID: 'union-agreement-2',
    orgID: MOCK_ORG_ID,
    createdAt: '2025-01-01T00:00:00.000Z',
    updatedAt: '2025-01-01T00:00:00.000Z',
    name: 'Workshop Technicians Agreement',
    startAt: '2025-01-01',
    endAt: '2026-12-31',
    limitationPeriod: 24,
    sickDays: 12,
    SickMinutes: 480,
    MinutesPerWeek: 2400,
    vacationDays: 28,
    weekRest: 36,
    dayRest: 11,
    onCallTime: 6,
    maxAnnulOverTime: 180,
    maxMonthlyOverTime: 45,
    maxFourWeekOvertime: 42,
    maxAnnualExceptionalOverTime: 120,
    status: 'Active',
    hourlyRate: '300',
    overTimeHourlyRate: [],
    inconvenienceHours: [],
  },
  {
    unionAgreementID: 'union-agreement-3',
    orgID: MOCK_ORG_ID,
    createdAt: '2024-01-01T00:00:00.000Z',
    updatedAt: '2024-01-01T00:00:00.000Z',
    name: 'Front Desk Staff Agreement',
    startAt: '2024-01-01',
    endAt: '2024-12-31',
    limitationPeriod: 12,
    sickDays: 8,
    SickMinutes: 480,
    MinutesPerWeek: 2000,
    vacationDays: 25,
    weekRest: 36,
    dayRest: 11,
    onCallTime: 4,
    maxAnnulOverTime: 100,
    maxMonthlyOverTime: 25,
    maxFourWeekOvertime: 24,
    maxAnnualExceptionalOverTime: 80,
    status: 'Inactive',
    hourlyRate: '250',
    overTimeHourlyRate: [],
    inconvenienceHours: [],
  },
]
